import { gql } from "@apollo/client";

export const publishOffer = gql`
  mutation PublishOffer($input: SetOfferPublishInput!) {
    publishOffer(input: $input)
  }
`;

export const unpublishOffer = gql`
  mutation UnpublishOffer($input: SetOfferPublishInput!) {
    unpublishOffer(input: $input)
  }
`;

export const acceptOfferParticipation = gql`
  mutation AcceptOfferParticipant($input: ApproveOfferParticipantInput!) {
    approveOfferParticipant(input: $input)
  }
`;

export const rejectOfferParticipation = gql`
  mutation RejectOfferParticipant($input: RejectOfferParticipantInput!) {
    rejectOfferParticipant(input: $input)
  }
`;

export const offerTransactionThread = gql`
  query OfferTransactionThread($input: OfferTransactionThreadInput!) {
    offerTransactionThread(input: $input) {
      uuid
      state
      message
      timeStamp
      sender_name
      from
    }
  }
`;

export const getClaimShareThread = gql`
  query GetClaimShareThread($offerClaimParticipantId: ID!, $claimId: ID!) {
    getClaimShareThread(
      offer_claim_participant_id: $offerClaimParticipantId
      claim_id: $claimId
    ) {
      body
      is_internal
      created_at
      claim_message_thread_id
      sender_name
      source
      is_read
    }
  }
`;

export const sendOfferParticipationMessage = gql`
  mutation SendOfferParticipationMessageMutation(
    $input: SendOfferParticipationMessage!
  ) {
    sendOfferParticipationMessage(input: $input)
  }
`;

export const postClaimMessage = gql`
  mutation PostClaimMessage(
    $claimId: ID!
    $body: String!
    $claimParticipantId: ID!
    $senderName: String!
    $source: String!
    $isInternal: Boolean
    $reinsurerEmail: String
  ) {
    postClaimMessage(
      claim_id: $claimId
      body: $body
      claim_participant_id: $claimParticipantId
      sender_name: $senderName
      source: $source
      is_internal: $isInternal
      reinsurer_email: $reinsurerEmail
    )
  }
`;

export const markClaimMessageRead = gql`
  mutation MarkClaimMessageRead($messageId: [ID]!, $senderName: String!) {
    markClaimMessageRead(message_id: $messageId, sender_name: $senderName)
  }
`;
